<template>
  <div class="slide last-jackpots gr-last-local active decoration">
    <div>
      <h3>{{$t('vdog_last_3_LocalJackpot')}}</h3>
      <div class="a-vg-c--last-jackpots-table">
          <div class="lj-table-head">
            <span>{{$t('ticket_id')}}</span>
            <span>{{$t('amount')}}</span>
          </div>
          <div class="lj-table-body">
            <div class="single-row" v-for="(jackpot, index) in winningJackpots" :key="index">
              <span class="id">{{partiallyMaskTicketId(jackpot.Barcode)}}</span>
              <span class="amount">{{format(jackpot.JackpotAmount)}} {{currency.toUpperCase()}}</span>
            </div>
          </div>
      </div>
    </div>
  </div>
</template>

<script>
// TODO SPOJITI LOCAL SLIDE I SUPER SLIDE U JEDNO
import NumberFormat from '@/mixins/NumberFormat'
import LanguageHelper from '@/mixins/LanguageHelper'
export default {
  mixins: [NumberFormat, LanguageHelper],
  props: {
    winningJackpots: {
      type: Array,
      default () {
        return []
      }
    },
    currency: {
      type: String,
      required: true
    }
  },
  methods: {
    format: function (value) {
      return this.formatNumber(value / 100, this.getLanguageCodeForNumbers())
    },
    partiallyMaskTicketId: function (ticketId) {
      if (ticketId && ticketId.length > 4) {
        return '*'.repeat(ticketId.length - 4) + ticketId.slice(-4)
      }
    }
  }
}
</script>
